(async() => {
    const { Core } = await importModule('Core');

    customElements.define('main-navigation-mobile', class extends Core {
        elements = {
            stage: '[data-stage]',
            navItems: '*[data-to-lvl]'
        }

        render() {
            this._handleNavigation();
        }
        
        _handleNavigation() {
            this.$navItems.map(item => {
                const tag = item.tagName.toLowerCase();
                if (!['a', 'button', 'input', 'select', 'textarea'].includes(tag)) {
                    item.setAttribute('role', 'button');
                    item.setAttribute('tabindex', '0');
                }

                item.addEventListener('click', () => {
                    this.$stage.dataset.current = item.dataset.toLvl;
                });

                item.addEventListener('keydown', event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        item.click();
                    }
                });
            })
        }
    });

})()